import { currencySymbolMap } from './currencySymbolMap';

export const getSymbolFromCurrency = (currencyCode: string): string => {
  if (typeof currencyCode !== 'string') {
    return '';
  }

  const code = currencyCode.toUpperCase();

  if (!Object.prototype.hasOwnProperty.call(currencySymbolMap, code)) {
    return currencyCode;
  }

  try {
    return currencySymbolMap[code];
  } catch (e) {
    return currencyCode;
  }
};
